import React, {useEffect} from 'react';
import './index.scss';
import router from './routing/router';
import {RouterProvider} from "react-router";
import {ThemeProvider} from "@emotion/react";
import {CssBaseline} from "@mui/material";
import {theme} from "./styling/theme";
import {LanguageProvider} from "./translations/LanguageProvider";
import LanguageHandler from "./translations/LanguageHandler";

const App = () => {
    useEffect(() => {
        LanguageHandler.setInitialAppLanguage()
    }, []);

    return (
        <React.StrictMode>
            <LanguageProvider>
                <ThemeProvider theme={theme}>
                    <CssBaseline>
                        <RouterProvider router={router}/>
                    </CssBaseline>
                </ThemeProvider>
            </LanguageProvider>
        </React.StrictMode>
    )
}

export default App;